<template>
  <div class="memberActions text-center">
    <MoreInfoPopover target='phone' width="auto">
      0800 243 779
    </MoreInfoPopover>
    <a
      href="#"
      @click="redirectLogout()"
      class="noStyle d-none d-md-inline-block"
    >Logout</a>

    <!-- <router-link :to="{name:'accountFavourites'}" class="noStyle d-none d-md-inline-block">My Favourites</router-link>-->
	<router-link :to="{name:'get-a-price'}" class="noStyle d-none d-md-inline-block">Request Price</router-link>

    <router-link :to="{name:'account'}" class="noStyle">My Account</router-link>

    <router-link :to="{name:'cart'}" class="noStyle"
    >Cart<CartIcon class="cartIcon" height="20px" />
      <span class="cartCount">{{this.$store.getters["cart/itemCount"]}}</span>
    </router-link>
  </div>
</template>

<script>
import CartIcon from "@/assets/img/cart.svg"
import MoreInfoPopover from"@/components/MoreInfoPopover"
export default {
  name: "MemberActions",
  components: {
    CartIcon,
    MoreInfoPopover
  },
  created(){
    this.$store.dispatch("cart/ensureCartValid")
  },
  methods:{
    redirectLogout(){
      this.$store.dispatch('auth/logout').then(() => {
        if(this.$route.name == "home"){
          this.$router.push({name:'home'})
          this.$router.go(0)
        } else{
          this.$router.push({name:'home'})
          this.$router.go(1)
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>


@include media-breakpoint-down(md){
  .memberActions{
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
.memberActions{
    a, span:first-child{
        color:$CTred;
        font-size: 0.8em;
        font-weight:bold;
        &:hover{
            text-decoration: underline;
        }
    }
    a:not(:last-of-type):after, span:first-child:after{
        content: "|";
        padding: 0 10px;

    }
}
@include media-breakpoint-down(lg){
  .memberActions{
    a:not(:last-of-type):after, span:first-child:after{
        content: "|";
        padding: 0 5px;

    }
  }
}

.cartIcon{
  margin-left:3px;
}

.cartCount {
  color: $CTred;
  vertical-align: super;
  font-size: 0.8em;
  margin-left:2px;
  // prevents items jumping when it loads
  min-width: 15px;
  display: inline-block;
}
</style>
